import React from 'react';
import { CheckCircleIcon, ClockIcon, ChevronRightIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export const Header = ({
  title = 'This OB/GYN Found Why 73% of Women with Recurring BV and Vaginal Odor Never Find Relief',
  subtitle = "Dr. Grace Holland is the first one to find out about this hidden bacterial shield that protects bad bacteria from every treatment you've tried",
  breadcrumbPageName = 'Biofilm Discovery',
  imageSrc = 'https://uploadthingy.s3.us-west-1.amazonaws.com/uchqAQbpyaudTs5Sv1NL7s/Screenshot_2025-09-20_at_11.21.12_AM.png',
  imageAlt = 'Female doctor in white coat with stethoscope in hospital room',
  authorName = 'Jessica Palmer',
  authorImage = 'https://uploadthingy.s3.us-west-1.amazonaws.com/wVLKgod3DUngKaLDgptxnJ/z0yfjbMtizCg7mAUjjxGb.jpg',
  breadcrumbFinal = breadcrumbPageName,
  views = '23,847',
  customBreadcrumbs = null
}) => {
  return <header className="mb-8 sm:mb-10" data-id="element-2410">
      {/* Journal masthead */}
      <div className="border-b-2 border-slate-800 mb-4" data-id="element-2411">
        <div className="flex items-center mb-2" data-id="element-2412">
          <div className="flex-shrink-0 mr-4" data-id="element-2413">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/b3PGU9GV81h1ZaHnnndvQZ/ddEpruXNUzZl9zX8arGEd.png" alt="Top Health Insider" className="h-10" data-id="element-2414" />
          </div>
          <div className="flex-grow" data-id="element-2415">
            <div className="text-xs text-slate-600 uppercase tracking-wider mb-1" data-id="element-2416">
              ADVERTORIAL
            </div>
            <div className="text-xs text-slate-600" data-id="element-2417">
              {(() => {
              const yesterday = new Date();
              yesterday.setDate(yesterday.getDate() - 1);
              const month = yesterday.toLocaleString('en-US', {
                month: 'long'
              }).toUpperCase();
              const day = yesterday.getDate();
              const year = yesterday.getFullYear();
              return `${month} ${day}, ${year}`;
            })()}
            </div>
          </div>
        </div>
      </div>
      {/* Breadcrumbs */}
      {customBreadcrumbs || <div className="flex items-center text-xs text-slate-500 mb-4" data-id="element-2418">
          <Link to="/" className="hover:text-slate-700 transition-colors" data-id="element-2419">
            Health
          </Link>
          <ChevronRightIcon className="h-3 w-3 mx-1" data-id="element-2420" />
          <Link to="/" className="hover:text-slate-700 transition-colors" data-id="element-2421">
            Women's Health
          </Link>
          <ChevronRightIcon className="h-3 w-3 mx-1" data-id="element-2422" />
          <span className="text-slate-700 font-medium" data-id="element-2423">
            {breadcrumbPageName}
          </span>
        </div>}
      {/* Article title and subtitle */}
      <div className="mb-6" data-id="element-2424">
        <h1 className="text-2xl sm:text-3xl md:text-4xl font-serif font-bold text-slate-900 leading-tight mb-3 sm:mb-4" data-id="element-2425">
          {title}
        </h1>
        {subtitle && <h2 className="text-lg sm:text-xl text-slate-700 font-normal leading-relaxed border-l-4 border-slate-300 pl-4" data-id="element-2426">
            {subtitle}
          </h2>}
      </div>
      {/* Author information with verification */}
      <div className="border-t border-b border-slate-200 py-3 mb-0" data-id="element-2427">
        <div className="flex flex-wrap items-center justify-between" data-id="element-2428">
          <div className="flex items-center mb-2 sm:mb-0" data-id="element-2429">
            <img src={authorImage} alt={authorName} className="w-8 h-8 rounded-full mr-3 object-cover border border-slate-200" data-id="element-2430" />
            <div data-id="element-2431">
              <div className="flex items-center" data-id="element-2432">
                <span className="text-sm font-medium text-slate-800 mr-1" data-id="element-2433">
                  Words by {authorName}
                </span>
                <CheckCircleIcon className="h-4 w-4 text-blue-600" title="Verified Author" data-id="element-2434" />
              </div>
              <div className="text-xs text-slate-500 mt-0.5" data-id="element-2435">
                {(() => {
                const yesterday = new Date();
                yesterday.setDate(yesterday.getDate() - 1);
                const month = yesterday.toLocaleString('en-US', {
                  month: 'long'
                });
                const day = yesterday.getDate();
                const year = yesterday.getFullYear();
                return `${month} ${day}, ${year}`;
              })()}
              </div>
            </div>
          </div>
          <div className="flex items-center space-x-4" data-id="element-2436">
            <div className="flex items-center text-xs text-slate-500" data-id="element-2437">
              <svg className="h-4 w-4 mr-1 text-slate-400" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-2438">
                <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" data-id="element-2439"></path>
                <circle cx="12" cy="12" r="3" data-id="element-2440"></circle>
              </svg>
              <span data-id="element-2441">{views} Views</span>
            </div>
            <div className="flex items-center text-xs text-slate-500" data-id="element-2442">
              <ClockIcon className="h-4 w-4 mr-1 text-slate-400" data-id="element-2443" />
              <span data-id="element-2444">(Avg. 3min Reading Time)</span>
            </div>
          </div>
        </div>
      </div>
      {/* Featured Image */}
      {imageSrc && <figure className="my-6 border border-slate-200 rounded-lg overflow-hidden" data-id="element-2445">
          <img src={imageSrc} alt={imageAlt} className="w-full h-auto object-cover" data-id="element-2446" />
          <figcaption className="text-xs text-slate-500 italic p-2 bg-slate-50" data-id="element-2447"></figcaption>
        </figure>}
    </header>;
};